import renderResource from '../resource/render-resource'

import createWidgetArea from '../widget/widget-area'
import creatProductLayoutWidgets from './lib/layout-widgets'

import creatSectionLayoutWidgets from '../section/lib/layout-widgets'
import widgetDefaultParams from '../section/lib/widget-default-params'
import buildDefaultParameters from '../section/lib/build-query'

const widgetArea = `
${createWidgetArea([
  ...creatSectionLayoutWidgets(),
  ...creatProductLayoutWidgets()
])}
`

const createQuery = () => {
  const productQuery = `...on Product {
    _id
    name
    slug
    price
    tagLine
    currencyISO
    primaryCtaText
    primaryCtaLink
    metaTitle
    metaDescription
    overview {
      ${widgetArea}
    }
    research {
      ${widgetArea}
    }
    pricing {
      ${widgetArea}
    }
    technical {
      ${widgetArea}
    }
    color1
    color2
    accentColor
    heroTitleColor
    heroCopyColor
    hideHeroImage
    description
    versionType
    pricingDetails {
      price
      billingType
      previousPrice
    }
    showDescription
    showPricing
    showTitleAndVersionType
    entitySection {
      layouts {
        product {
          layout {
            attributes
            cols {
              width
              widgetArea {
                ${widgetArea}
              }
            }
          }
        }
      }
    }
    images {
      hero_1x1_200 {
        url
        caption
        link
      }
      hero_1x1_500 {
        url
        caption
        link
      }
      hero_2x1_600 {
        url
        caption
        link
      }
      hero_2x1_800 {
        url
        caption
        link
      }
      hero_2x1_1000 {
        url
        caption
        link
      }
      hero_2x1_1280 {
        url
        caption
        link
      }
      hero_16x9_1920 {
        url
      }
    }
  }`
  return renderResource(
    productQuery,
    buildDefaultParameters(productQuery, widgetDefaultParams)
  )
}

export default createQuery
